import { lock } from "../../contracts/0x2/kiosk.mjs";
import { feeAmount, pay } from "../../contracts/kiosk/royalty_rule.mjs";
import { prove } from "../../contracts/kiosk/kiosk_lock_rule.mjs";
import { prove as prove$1 } from "../../contracts/kiosk/personal_kiosk_rule.mjs";
import { prove as prove$2 } from "../../contracts/kiosk/floor_price_rule.mjs";
import { bcs } from "@safecoin/safe/bcs";
import { normalizeSafeAddress } from "@safecoin/safe/utils";
import { Transaction } from "@safecoin/safe/transactions";
//#region src/tx/rules/resolve.ts
/**
* A helper to resolve the royalty rule.
*/
async function resolveRoyaltyRule(params) {
	const { transaction: tx, itemType, price, packageId, transferRequest, policyId, kioskClient } = params;
	const feeTx = new Transaction();
	feeTx.add(feeAmount({
		package: packageId,
		arguments: {
			policy: feeTx.object(policyId),
			paid: BigInt(price || "0")
		},
		typeArguments: [itemType]
	}));
	const policyObj = tx.object(policyId);
	let amount = null;
	try {
		feeTx.setSender(tx.getData().sender || normalizeSafeAddress("0x0"));
		const txBytes = await feeTx.build({ client: kioskClient.client });
		const result = await kioskClient.client.core.simulateTransaction({
			transaction: txBytes,
			include: { commandResults: true }
		});
		if (result.commandResults && result.commandResults.length > 0) {
			const returnedAmount = result.commandResults[0]?.returnValues?.[0]?.bcs;
			if (returnedAmount) amount = BigInt(bcs.U64.parse(returnedAmount));
		}
	} catch {}
	if (!amount) [amount] = tx.add(feeAmount({
		package: packageId,
		arguments: {
			policy: policyObj,
			paid: BigInt(price || "0")
		},
		typeArguments: [itemType]
	}));
	const feeCoin = tx.splitCoins(tx.gas, [amount]);
	tx.add(pay({
		package: packageId,
		arguments: {
			policy: policyObj,
			request: transferRequest,
			payment: feeCoin
		},
		typeArguments: [itemType]
	}));
}
function resolveKioskLockRule(params) {
	const { transaction: tx, packageId, itemType, kiosk: kioskId, kioskCap, policyId, purchasedItem, transferRequest } = params;
	if (!kioskId || !kioskCap) throw new Error("Missing Owned Kiosk or Owned Kiosk Cap");
	tx.add(lock({
		arguments: [
			kioskId,
			kioskCap,
			policyId,
			purchasedItem
		],
		typeArguments: [itemType]
	}));
	tx.add(prove({
		package: packageId,
		arguments: {
			request: transferRequest,
			kiosk: tx.object(kioskId)
		},
		typeArguments: [itemType]
	}));
}
/**
* A helper to resolve the personalKioskRule.
* @param params
*/
function resolvePersonalKioskRule(params) {
	const { transaction: tx, packageId, itemType, kiosk, transferRequest } = params;
	if (!kiosk) throw new Error("Missing owned Kiosk.");
	tx.add(prove$1({
		package: packageId,
		arguments: {
			kiosk: tx.object(kiosk),
			request: transferRequest
		},
		typeArguments: [itemType]
	}));
}
/**
* A helper to resolve the floor price rule.
* The floor price rule verifies that the paid amount meets the minimum price.
* @param params
*/
function resolveFloorPriceRule(params) {
	const { transaction: tx, packageId, itemType, policyId, transferRequest } = params;
	tx.add(prove$2({
		package: packageId,
		arguments: {
			policy: tx.object(policyId),
			request: transferRequest
		},
		typeArguments: [itemType]
	}));
}
//#endregion
export { resolveFloorPriceRule, resolveKioskLockRule, resolvePersonalKioskRule, resolveRoyaltyRule };

//# sourceMappingURL=resolve.mjs.map